import { Box, Card, CardActionArea, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { RootState } from "config/store";
import { round } from "lodash";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { getFileByPath } from "shared/network/file.api";

const SellingFormItemItem = ({
  item,
  setIsDialogOpen,
  price,
  tax,
  selectedCurrency,
  append,
}: {
  item: any;
  setIsDialogOpen: any;
  price: number;
  tax: number;
  selectedCategory: any;
  selectedCurrency: any;
  append: any;
}) => {
  const { t } = useTranslation();
  const { selectedRelTenant } = useSelector((state: RootState) => state.authentication);
  const tenant = selectedRelTenant?.tenant;
  const form = useFormContext();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const profilePicQuery = useQuery(
    ["deliveryDeliveryItemDialog", item?.profilePath],
    async () => {
      if (item?.profilePath) {
        const { data } = await getFileByPath(item?.profilePath, tenant?.id);
        const file = new Blob([data], { type: "image/jpeg" });
        const fileURL = URL.createObjectURL(file);
        return fileURL;
      }
      return Promise.reject();
    },
    { enabled: !!item?.profilePath },
  );

  return (
    <Card
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",

        cursor: "pointer",
        boxShadow: "0px 4px 16px rgba(25, 118, 210, 0.10)",
        border: "2px solid #e3f2fd",
        background: "linear-gradient(90deg, #e3f2fd 60%, #fffde7 100%)",
        position: "relative",
        transition: "box-shadow 0.2s, border 0.2s, background 0.2s",
      }}
    >
      <CardActionArea
        style={{
          padding: "8px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          height: "100%",
          background: "transparent",
        }}
        onClick={() => {
          const existingIndex = form
            .getValues("relOrderItem")
            ?.findIndex((value: any) => value.item.id === item.id);
          if (existingIndex !== undefined) {
            if (existingIndex !== -1) {
              const currentQuantity = form.getValues(`relOrderItem.${existingIndex}.quantity`);
              form.setValue(
                `relOrderItem.${existingIndex}.quantity`,
                Number(currentQuantity || 0) + 1,
              );
            } else {
              append({ item: item, quantity: 1 });
            }
          }
          if (isSmallScreen) {
            setIsDialogOpen(false);
          }
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            background: "#fff",
            marginBottom: 12,
            boxShadow: "0 2px 8px 0 rgba(25, 118, 210, 0.06)",
            overflow: "hidden",
            border: "1.5px solid #e0e0e0",
          }}
        >
          {profilePicQuery.isLoading ? (
            <Skeleton variant="circle" width={60} height={60} />
          ) : profilePicQuery.data ? (
            <img
              src={profilePicQuery?.data}
              alt={item.name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          ) : (
            <Box
              width="100%"
              height="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{ color: "#bdbdbd", fontSize: 32 }}
            >
              <span role="img" aria-label="item">
                🛒
              </span>
            </Box>
          )}
        </Box>
        <Typography
          style={{
            fontWeight: "bold",
            fontSize: 14,
            color: "#1976d2",
            textAlign: "center",
            marginBottom: 4,
            fontFamily: "Montserrat, sans-serif",
            lineHeight: 1.2,
            width: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            whiteSpace: "normal",
            minHeight: 36,
          }}
          title={item.name}
        >
          {item.name}
        </Typography>
        <Typography
          style={{
            textAlign: "center",
            width: "100%",
            fontWeight: 500,
            fontSize: 15,
            color: "#333",
          }}
        >
          {t("common:currency", {
            num: round(price * (1 + tax), 2),
            cur: selectedCurrency?.postfix,
          })}
        </Typography>
      </CardActionArea>
    </Card>
  );
};

export default SellingFormItemItem;
